document.querySelectorAll('img[loading="lazy"] + .lazy-preloader').forEach((preloader) => {
    var _a;
    const img = preloader.previousElementSibling;
    if (img && img.tagName === 'IMG' && ((_a = img.getAttribute('loading')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'lazy') {
        // Check if image is already loaded
        if (img.complete) {
            preloader.remove();
        }
        else {
            // Add event listeners for when the image loads or fails to load
            img.addEventListener('load', () => {
                preloader.remove();
            });
            // Hide preloader even if image fails to load
            img.addEventListener('error', () => {
                preloader.remove();
            });
        }
    }
    ;
});
